import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ExternalServiceLog } from '../../../models/external-service-log.model';
import { ExternalServiceLogService } from '../../../services/external-service-log.service';

@Component({
  selector: 'app-external-service-log-page',
  templateUrl: './external-service-log-page.component.html',
  styleUrl: './external-service-log-page.component.scss'
})
export class ExternalServiceLogPageComponent {

  public externalServiceLogId: string = '';
  public neighborhoodId: string = '';
  public log: ExternalServiceLog | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    public externalServiceLogService: ExternalServiceLogService,
    private location: Location
  ) {
    this.activatedRoute.params.subscribe(async params => {
      this.externalServiceLogId = params['externalServiceLogId'];
      this.neighborhoodId = params['neighborhoodId'] ?? '';
      await this.getData();
    });
  }

  /*
   ██████╗ ███████╗████████╗██████╗  █████╗ ████████╗ █████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║  ███╗█████╗     ██║   ██║  ██║███████║   ██║   ███████║
  ██║   ██║██╔══╝     ██║   ██║  ██║██╔══██║   ██║   ██╔══██║
  ╚██████╔╝███████╗   ██║   ██████╔╝██║  ██║   ██║   ██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  // region getData
  async getData(): Promise<void> {
    this.log = await this.externalServiceLogService.get(
      this.externalServiceLogId
    );
  }

  /*
   ██████╗  ██████╗     ██████╗  █████╗  ██████╗██╗  ██╗
  ██╔════╝ ██╔═══██╗    ██╔══██╗██╔══██╗██╔════╝██║ ██╔╝
  ██║  ███╗██║   ██║    ██████╔╝███████║██║     █████╔╝
  ██║   ██║██║   ██║    ██╔══██╗██╔══██║██║     ██╔═██╗
  ╚██████╔╝╚██████╔╝    ██████╔╝██║  ██║╚██████╗██║  ██╗
   ╚═════╝  ╚═════╝     ╚═════╝ ╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝

  */
  // region goBack
  goBack(): void {
    this.location.back();
  }

}
